
export default async function ConnectivityChecker() {

    let condition = navigator.onLine ? 'online' : 'offline';
    try {
        if (condition === 'online'){
            let response = await fetch('https://www.phoenix.gov', {
                mode: 'no-cors',
            });
            //console.log("response: ", response);
            return true;
        } else {
            //console.log("NAVIGATOR IS OFFLINE");
            return false;
        }

    } catch (error) {
        //console.log("fetch error: ", error);
        return false;
    }
};

